import { render, staticRenderFns } from "./ComplaintsPerMonth.vue?vue&type=template&id=e266aa4e&scoped=true&"
import script from "./ComplaintsPerMonth.vue?vue&type=script&lang=js&"
export * from "./ComplaintsPerMonth.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsPerMonth.vue?vue&type=style&index=0&id=e266aa4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e266aa4e",
  null
  
)

export default component.exports